module.exports = __webpack_public_path__ + "img/photo.df5cfcd8.svg";